define('core/modules/contentList',["jquery", "core/ef_plugins/equalheight"], function ($) {
    console.log('contentList');
    return {
        init: function() {
            var plugin = $('.content-list').data('plugin_equalheight');
            if (plugin == undefined) {
                $('.content-list').equalheight({ "childSelector": ".content-list-item" });
            } else {
                plugin.updateHeight();
            }
        }
    };
});
